import { render, staticRenderFns } from "./RewardsSignupSidePanel.vue?vue&type=template&id=7bf21e74"
import script from "./RewardsSignupSidePanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./RewardsSignupSidePanel.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./RewardsSignupSidePanel.vue?vue&type=style&index=0&id=7bf21e74&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports